import React, {ReactNode} from "react"
import Button from "@mui/material/Button";

interface Props {
    backgroundColor: string,
    children: ReactNode,
    color: string,
    id: number | string,
    url: string,
}

const CCOLinkButton = ({id, url, children, backgroundColor, color}: Props) =>
    <Button key={id}
            variant={'contained'}
            href={url}
            sx={{
                backgroundColor: backgroundColor,
                color: color,
                filter: 'brightness(1)',
                '&:hover': {
                    backgroundColor: 'tertiary.main',
                    filter: 'brightness(0.95)',
                    transition: 'filter .2s linear',
                }
            }}>
        {children}
    </Button>

export default CCOLinkButton